import createIcon from '../../createIcon';

/**
 * @component @name TapAndPlay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDE2VjE4QzYuMjYgMTggOC41IDIwLjI0IDguNSAyM0gxMC41QzEwLjUgMTkuMTMgNy4zNyAxNiAzLjUgMTZaTTMuNSAyMFYyM0g2LjVDNi41IDIxLjM0IDUuMTYgMjAgMy41IDIwWk0zLjUgMTJWMTRDOC40NyAxNCAxMi41IDE4LjAzIDEyLjUgMjNIMTQuNUMxNC41IDE2LjkyIDkuNTggMTIgMy41IDEyWk0xOC41IDEuMDFMOC41IDFDNy40IDEgNi41IDEuOSA2LjUgM1YxMC4zN0M3LjE5IDEwLjUzIDcuODYgMTAuNzQgOC41IDExLjAxVjVIMTguNVYxOEgxNS40N0MxNS45OSAxOS4yNSAxNi4zMSAyMC41OSAxNi40MiAyMkgxOC41QzE5LjYgMjIgMjAuNSAyMS4xIDIwLjUgMjBWM0MyMC41IDEuOSAxOS42IDEuMDEgMTguNSAxLjAxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TapAndPlay = createIcon('TapAndPlay', [
  [
    'path',
    {
      d: 'M3.5 16V18C6.26 18 8.5 20.24 8.5 23H10.5C10.5 19.13 7.37 16 3.5 16ZM3.5 20V23H6.5C6.5 21.34 5.16 20 3.5 20ZM3.5 12V14C8.47 14 12.5 18.03 12.5 23H14.5C14.5 16.92 9.58 12 3.5 12ZM18.5 1.01L8.5 1C7.4 1 6.5 1.9 6.5 3V10.37C7.19 10.53 7.86 10.74 8.5 11.01V5H18.5V18H15.47C15.99 19.25 16.31 20.59 16.42 22H18.5C19.6 22 20.5 21.1 20.5 20V3C20.5 1.9 19.6 1.01 18.5 1.01Z',
      key: 'mpma68',
    },
  ],
]);

export default TapAndPlay;
